import { AppError } from "@/lib/utils/errors";
import { contactSupportService } from "@/modules/services/contactSupportService";
import {
  ContributeFeatureInfo,
  RegistWishlistInfo,
  UserRoleEnum,
} from "@/modules/types/contactsupport/contactsupport";
import { useState } from "react";

export const useJoinWishlist = () => {
  const [pending, setPending] = useState(false);
  const [message, setMessage] = useState("");

  const joinWishlist = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    setPending(true);
    setMessage("");

    const formData = new FormData(form);
    const email = formData.get("email") as string;
    const userRole = formData.get("userRole") as UserRoleEnum;
    const wishList: RegistWishlistInfo = {
      email,
      userRole,
    };
    try {
      await contactSupportService.registWishlist(wishList);
      setMessage(
        "Cảm ơn bạn đã tham gia wishlist của Together Work! chúng tôi sẽ liên hệ bạn khi chúng tôi ra mắt sản phẩm và sẽ có những ưu đãi đặc biệt dành cho bạn.",
      );
      form.reset();
    } catch (err) {
      const appErr = new AppError(err);
      appErr.logError();
      setMessage(appErr.message);
    } finally {
      setPending(false);
      setTimeout(() => {
        setMessage("");
      }, 5000);
    }
  };

  return {
    pending,
    message,
    joinWishlist,
  };
};

export const useContributeFeature = () => {
  const [pending, setPending] = useState(false);
  const [message, setMessage] = useState("");

  const contributeFeature = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    setPending(true);
    setMessage("");
    const formData = new FormData(form);
    const email = formData.get("email") as string;
    const userRole = formData.get("userRole") as UserRoleEnum;
    const descriptionFeature = formData.get("descriptionFeature") as string;
    const contributeFeature: ContributeFeatureInfo = {
      email,
      userRole,
      descriptionFeature,
    };
    try {
      await contactSupportService.contributeFeature(contributeFeature);
      setMessage(
        "Cảm ơn bạn đã đóng góp ý kiến cho Together Work! Chúng tôi rất trân trọng các ý kiến đóng góp từ bạn. Chúng tôi sẽ có những ưu đãi đặc biệt dành cho bạn khi bạn trở thành khách hàng của chúng tôi.",
      );
      form.reset();
    } catch (err) {
      const appErr = new AppError(err);
      appErr.logError();
      setMessage(appErr.message);
    } finally {
      setPending(false);
      setTimeout(() => {
        setMessage("");
      }, 5000);
    }
  };

  return {
    pending,
    message,
    contributeFeature,
  };
};
